import { put, takeLatest } from "redux-saga/effects";
import { requestOwnerList ,requestCreateOwner, requestUpdateOwner} from "services/manage-property/property-owner/owner";

import {
  fetchOwnerListRequest,
  fetchOwnerListSuccess,
  fetchOwnerListFailure,

  createOwnerRequest,
  createOwnerSuccess,
  createOwnerFailure,
  updateOwnerRequest,
  updateOwnerSuccess,
  updateOwnerFailure
} from "../../../../actions/manage-property/property-owner/owner/owner-list";

import {
  FETCH_OWNER_LIST_REQUEST,
  FETCH_OWNER_LIST_SUCCESS,
  FETCH_OWNER_LIST_FAILURE,
  CREATE_OWNER_REQUEST,
  UPDATE_OWNER_REQUEST
} from "../../../../actions/manage-property/property-owner/owner/types";

export function* watchOwnerListSaga() {
  yield takeLatest(FETCH_OWNER_LIST_REQUEST, fetchOwnerList);
  yield takeLatest(CREATE_OWNER_REQUEST, createOwner);
  yield takeLatest(UPDATE_OWNER_REQUEST, updateOwner);
}

function* fetchOwnerList({ payload }) {
  try {
    /**
     * @type {FetchBrokerFirmsResponse}
     */
    const response = yield requestOwnerList(payload);
    yield put(fetchOwnerListSuccess(response));
  } catch (error) {
    yield put(fetchOwnerListFailure("Failed to get list of Owner list"));
  }
}



/**
 *
 * @param {PARAMS} param0
 */
 function* createOwner({ payload }) {
  try {
      const owner = yield requestCreateOwner(payload);
      yield put(createOwnerSuccess(owner.data));
  } catch (error) {
      yield put(
        createOwnerFailure('Failed to get list of Owner')
      );
  }
}

/**
*
* @typedef {Object} BrokerFirmUpdatePayload
* @property {BrokerFirm} payload
*
* @param {BrokerFirmUpdatePayload} param0
*/
function* updateOwner({ payload }) {
  try {
      yield requestUpdateOwner(payload);
      yield put(updateOwnerSuccess(payload));
  } catch (error) {
      yield put(
          updateOwnerFailure('Failed to get list of Owner')
      );
  }
}